export const reduceWithoutExtraCharges = (acc, [key, value]) => {
  const isExtraCharge = key.includes('extra-charge');
  if (isExtraCharge) return acc;

  acc[key] = value;

  return acc;
};
